import { useLocation } from 'react-router-dom'
import { asKnownLoginFailureReason } from '@/auth/auth-errors'
import { HttpErrorKind, HttpErrorPage } from '@/pages/errors/HttpError'

/**
 * Shown when a session is rejected or a sign-in fails.
 *
 * `AuthCallback` navigates here with a machine-readable `reason` (e.g.
 * `LOGIN_CODE_EXCHANGE_FAILED`) on the location state. It is rendered as a
 * small diagnostic code so a failed sign-in can be reported and traced rather
 * than being an anonymous error screen — the value is always a fixed constant,
 * never a token, user identifier or raw error message.
 *
 * The incoming state is untrusted, so the reason is narrowed to a code this app
 * defines before it is rendered; anything else is ignored. The two account
 * codes belong to `/error/no-access` and are never shown here (TO-361 REQ-007).
 * It is the 401 kind of the HTTP error family (TO-640).
 */
export function UnauthorizedPage() {
	const { state } = useLocation() as { state: { reason?: unknown } | null }
	const reason = asKnownLoginFailureReason(state?.reason)
	return <HttpErrorPage kind={HttpErrorKind.Unauthorized} reason={reason} />
}
